{
  "slug": "how-can-i-find-out-my-iq",
  "title": "How can I find out my IQ?",
  "description": "Compare online IQ-style tests with supervised professional assessment and learn how to obtain and interpret a credible cognitive score.",
  "summary": "The right way to find out your IQ depends on the purpose. A careful online test can provide an indicative estimate, while clinical, educational, or eligibility decisions require a suitable supervised assessment.",
  "category": "IQ essentials",
  "sections": [
    {
      "heading": "Start with the reason you want a score",
      "paragraphs": [
        "Curiosity, practice, educational planning, clinical evaluation, and membership qualification are different goals. An informal online estimate may answer a curiosity question but cannot substitute for a protected professional instrument.",
        "If the result may affect treatment, accommodations, schooling, employment, or a formal application, ask a qualified psychologist or the relevant organization which test and documentation it accepts."
      ]
    },
    {
      "heading": "What to look for in an online test",
      "paragraphs": [
        "A responsible online test explains what it samples, how long it takes, how comparison scores are produced, and what it cannot establish. It should protect personal data and avoid claiming diagnosis or guaranteed precision.",
        "Take the assessment when rested, use a quiet environment, follow the timing rules, and avoid outside help. Repeating the same items can create practice effects, so a later result is not automatically a better estimate."
      ]
    },
    {
      "heading": "What professional testing adds",
      "paragraphs": [
        "A professional assessment uses standardized administration, secure materials, appropriate age norms, multiple subtests, and behavioral observations. The resulting report may include index scores, confidence intervals, and interpretation of meaningful differences.",
        "Ask for the instrument name and edition, the norm group, score type, confidence interval, and limits. Keep the original report if you may later need proof of a qualifying result."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Can a free online test tell me my exact IQ?",
      "answer": "It can provide an indicative estimate if it is well designed, but it cannot establish an exact, permanent, or clinical score."
    },
    {
      "question": "Who can administer an official IQ test?",
      "answer": "Requirements vary by country and instrument. Standardized clinical tests are typically administered and interpreted by appropriately qualified professionals."
    }
  ],
  "related": ["is-an-online-iq-test-accurate", "how-is-iq-measured", "free-online-iq-test-guide"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — intelligence test",
      "url": "https://dictionary.apa.org/intelligence-test"
    },
    {
      "label": "Pearson — WAIS-5 sample score report",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    },
    {
      "label": "Mensa International — getting your IQ tested",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    }
  ]
}
